export default {
  AREA_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...(value.sort((a, b) => (a.name > b.name) ? 1 : -1))] : []
  },
  AREA_LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        building: value.building
      })
    }
  },
  AREA_LIST_ITEM_REMOVE (state, value) {
    const id = typeof value === 'string' ? value : typeof value === 'object' && value.id ? value.id : ''
    const index = state.list.findIndex((i) => i.id === id)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  AREA_LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(value)
    }
  },
  AREA_CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'building']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.schedules = value.schedules
      state.current.rooms = value.rooms
    } else {
      state.current = {
        id: '',
        name: '',
        building: '',
        schedules: [],
        rooms: []
      }
      state.update = {
        id: '',
        name: ''
      }
    }
  },
  AREA_UPDATE_NAME (state, value) {
    state.update.name = value
  }
}
